import React from "react";
import TabellaClassiTipiImpExpDatiViewr from "./TabellaClassiTipiImpExpDatiView";

export default function TabellaClassiTipiImpExpDatiController({
                                                        classiImpExp,
                                                        translate,
                                                        setClasseSel,
                                                        setShowConfirm,
                                                        history,
                                                    }) {

    function onClickElimina(row) {
        setClasseSel(row)
        setShowConfirm(true);
    }

    function onRowDbClickClasse(row) {
        history.push("/upd-classe-imp-exp/" + row.id_classe_tipo_imp_exp);
    }

    return (
        <TabellaClassiTipiImpExpDatiViewr
            classiImpExp={classiImpExp}
            translate={translate}
            onClickElimina={onClickElimina}
            onRowDbClickClasse={onRowDbClickClasse}
        />
    );
}